((d, w) => {
  const btn = d.getElementById("menu-button");
  const body = d.querySelector("body");
  const overlay = d.querySelector(".overlay");
  const siteHeader = d.querySelector(".site-header");
 
  console.log(btn, overlay);
  
  const openCssClass = "overlay-show";
  let isOpen = false;

  const showOverlay = () => {
    isOpen = true;
    body.classList.add(openCssClass);
    btn.classList.add("is-active");
    body.classList.add("menu-open");
  };

  const hideOverlay = () => {
    isOpen = false;
    body.classList.remove(openCssClass);
    btn.classList.remove("is-active");
    body.classList.remove("menu-open");
  };

  const toggleMenu = () => {
    console.log('click');
    if (isOpen) {
      hideOverlay();
    } else {
      showOverlay();
    }
  };

  if (overlay) {
    d.addEventListener("click", function (event) {
      const isClickInside = siteHeader.contains(event.target);
      if (!isClickInside) {
        hideOverlay();
      }
    });

    d.addEventListener("keydown", (e) => {
      if (e.code === "Escape") hideOverlay();
    });

    btn.addEventListener("click", () => toggleMenu());
  }
})(document, window);
